<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: 'auto' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="close()"
  [header]="model ? 'Editar Artículo' : 'Nuevo Artículo'"
>
  <div>
    <form [formGroup]="form" (ngSubmit)="model ? update(form.value) : create(form.value)" appPermissionControl="P100F0001">
      <div class="form-row mt-3">
        <div class="form-field">
          <label for="numero_articulo">Número de Artículo</label>
          <input
            type="number"
            id="numero_articulo"
            formControlName="numero_articulo"
            class="form-control"
            [class.is-invalid]="formValue('numero_articulo')?.invalid && formValue('numero_articulo')?.touched"
            appPermissionControl="P100K0001"
          />
          <div class="invalid-feedback" *ngIf="formValue('numero_articulo')?.invalid && formValue('numero_articulo')?.touched">
            <span *ngIf="formValue('numero_articulo')?.errors?.['required']">Este campo es requerido</span>
            <span *ngIf="formValue('numero_articulo')?.errors?.['pattern']">Solo se permiten números</span>
          </div>
        </div>
        <div class="form-field">
          <label for="numero_linea">Número de Línea</label>
          <select
            id="numero_linea"
            formControlName="numero_linea"
            class="form-control"
            [class.is-invalid]="formValue('numero_linea')?.invalid && formValue('numero_linea')?.touched"
            appPermissionControl="P100K0002"
          >
            <option value appPermissionControl="P100K0003">Seleccione una línea</option>
            <option *ngFor="let linea of listLineas" [value]="linea.numero_linea" appPermissionControl="P100K0004">{{ linea.numero_linea }} | {{ linea.descripcion }}</option>
          </select>
          <div class="invalid-feedback" *ngIf="formValue('numero_linea')?.invalid && formValue('numero_linea')?.touched">Este campo es requerido</div>
        </div>
        <div class="form-field">
          <label for="descripcion">Descripción</label>
          <input
            type="text"
            id="descripcion"
            formControlName="descripcion"
            class="form-control"
            [class.is-invalid]="formValue('descripcion')?.invalid && formValue('descripcion')?.touched"
            appPermissionControl="P100K0005"
          />
          <div class="invalid-feedback" *ngIf="formValue('descripcion')?.invalid && formValue('descripcion')?.touched">Este campo es requerido</div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <label for="precio">Precio</label>
          <input
            type="number"
            id="precio"
            formControlName="precio"
            class="form-control"
            [class.is-invalid]="formValue('precio')?.invalid && formValue('precio')?.touched"
            appPermissionControl="P100K0006"
          />
          <div class="invalid-feedback" *ngIf="formValue('precio')?.invalid && formValue('precio')?.touched">
            <span *ngIf="formValue('precio')?.errors?.['required']">Este campo es requerido</span>
            <span *ngIf="formValue('precio')?.errors?.['pattern']">Solo se permiten números</span>
          </div>
        </div>
        <div class="form-field">
          <label for="precio_Propio">Precio Propio</label>
          <input
            type="number"
            id="precio_Propio"
            formControlName="precio_Propio"
            class="form-control"
            [class.is-invalid]="formValue('precio_Propio')?.invalid && formValue('precio_Propio')?.touched"
            appPermissionControl="P100K0007"
          />
          <div class="invalid-feedback" *ngIf="formValue('precio_Propio')?.invalid && formValue('precio_Propio')?.touched">
            <span *ngIf="formValue('precio_Propio')?.errors?.['required']">Este campo es requerido</span>
            <span *ngIf="formValue('precio_Propio')?.errors?.['pattern']">Solo se permiten números</span>
          </div>
        </div>
        <div class="form-field">
          <label for="fecha_Cotizacion">Fecha Cotización</label>
          <input
            type="date"
            id="fecha_Cotizacion"
            formControlName="fecha_Cotizacion"
            class="form-control"
            [class.is-invalid]="formValue('fecha_Cotizacion')?.invalid && formValue('fecha_Cotizacion')?.touched"
            appPermissionControl="P100K0008"
          />
          <div class="invalid-feedback" *ngIf="formValue('fecha_Cotizacion')?.invalid && formValue('fecha_Cotizacion')?.touched">Este campo es requerido</div>
        </div>
      </div>

      <footer class="footer-form">
        <div class="button-section">
          <button mat-flat-button class="btn-success" [disabled]="form.invalid || loading" (click)="model ? update(model) : create(model)" appPermissionControl="P100B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
          </button>
          <button *ngIf="model" type="button" mat-flat-button class="btn-search" (click)="customizables()" appPermissionControl="P100B0002">
            <mat-icon>settings</mat-icon>
            Customizables
          </button>
        </div>
      </footer>
    </form>
  </div>
</p-dialog>
